export default import.meta.ROLLDOWN_FILE_URL_$$e1hPbTARmLZxiCV0vVfA